import DateComponent from './DateComponent';

export default DateComponent;
